import React, { useEffect, useState, useMemo } from 'react';
import { ApplicationRoles } from './api-authorization/ApiAuthorizationConstants';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge"

import liveRoomService from '../services/LiveRoomService';
import authorizeService from './api-authorization/AuthorizeService';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { HubConnectionBuilder } from '@microsoft/signalr';
import fixtureService from '../services/FixtureService';
import teamsService from '../services/TeamsService';
import calendarService from '../services/CalendarService';

import FixtureDetailsModal from './Modals/FixtureDetailsModal';

const Home = (props) => {
    const typaheadRef = React.createRef();

    const [fixtures, setFixtures] = useState(null);
    const [sortConfig, setSortConfig] = React.useState({ key: 'homeTeamName', direction: 'ascending' });
    const [teamNames, setTeamNames] = useState(null);
    const [search, setSearch] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showFixtureDetailsModal, setShowFixtureDetailsModal] = React.useState(false);

    const [selectedFixture, setSelectedFixture] = React.useState(null);

    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (!userRole) {
            authorizeService.getUserRole().then((role) => {
                setUserRole(role);
            });
        }
    }, []);

    useEffect(() => {
        if (!fixtures) {
            fixtureService.getFixtureList().then((list) => {
                setFixtures(list);
                setLoading(false);
            });
        }
    }, []);

    useEffect(() => {
        if (!teamNames) {
            teamsService.getTeamNames().then((teamNames) => {
                setTeamNames(teamNames);
                setLoading(false);
            });
        }
    }, []);

    const hideModal = () => {
        fixtureService.getFixtureList().then((list) => {
            setFixtures(list);
        });
        setShowFixtureDetailsModal(false);
    }

    const renderModal = () => {
        if (selectedFixture) {
            return <FixtureDetailsModal
                show={showFixtureDetailsModal}
                onHide={hideModal}
                userRole={userRole}
                fixture={selectedFixture}>
            </FixtureDetailsModal>;
        }
        else
            return <></>;
    }

    const setSort = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    }

    const renderDropdown = (teamNames, setSearch) => {
        if (teamNames) {
            let typaheadTeams = teamNames.map((x) => {
                return { id: x, label: x }
            });

            return <Typeahead
                id="my-typeahead-id"
                ref={typaheadRef}
                clearButton
                multiple
                onChange={(selected) => {
                    if (selected && selected.length > 0) {
                        setSearch(selected.map(x => x.id));
                    } else {
                        setSearch(null);
                    }
                }}
                options={typaheadTeams}
                placeholder="Type to search teams"
            />
        }
        return <></>
    }

    const renderTable = (fixtures) => {
        const content = !fixtures || fixtures.length == 0 ? (
            <tr className="p-2"><td colSpan="7" className="text-center">No Fixtures</td></tr>
        ) : (fixtures.map((x) => {

            return (
                <tr key={x.fixtureId}>
                    <td>{x.homeTeamName}</td>
                    <td>{x.awayTeamName}</td>
                    <td>{x.kickoffTimeString}</td>
                    <td>{x.competitionName}</td>
                    <td>{x.result ?? ''}</td>
                    <td>{x.tags ? x.tags.map(x => <Badge key={x.text} className="ml-1" variant={x.variant}>{x.text}</Badge>) : []}</td>
                    <td>
                        <Button size="sm"
                            variant="outline-info"
                            className="ml-2"
                            onClick={async (clickInfo) => {
                                setSelectedFixture(x);
                                setShowFixtureDetailsModal(true);
                            }}>Details</Button>
                    </td>
                </tr>
            );
        }));

        let homeTeamNameSortClass = sortConfig && sortConfig.key == 'homeTeamName' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';
        let awayTeamNameSortClass = sortConfig && sortConfig.key == 'awayTeamName' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';
        let kickoffSortClass = sortConfig && sortConfig.key == 'kickoff' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';
        let competitionNameSortClass = sortConfig && sortConfig.key == 'competitionName' ? (sortConfig.direction == 'ascending' ? 'asc' : 'desc') : '';

        return (
            <>
                <div style={{ overflowY: 'scroll', overflowX: 'scroll', whiteSpace: 'nowrap', maxHeight: 'calc(100vh - 180px)' }}>
                    <Table striped bordered hover className="react-bootstrap-table">
                        <thead>
                            <tr>
                                <th className={'sortable ' + homeTeamNameSortClass} onClick={() => setSort('homeTeamName')}>
                                    Home Team
                                    <div></div>
                                </th>
                                <th className={'sortable ' + awayTeamNameSortClass} onClick={() => setSort('awayTeamName')}>
                                    Away Team
                                    <div></div>
                                </th>
                                <th className={'sortable ' + kickoffSortClass} onClick={() => setSort('kickoff')}>
                                    Kickoff
                                     <div></div>
                                </th>
                                <th className={'sortable ' + competitionNameSortClass} onClick={() => setSort('competitionName')}>
                                    Competition Name
                                     <div></div>
                                </th>
                                <th>Result</th>
                                <th>Tags</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {content}
                        </tbody>
                    </Table>
                </div>
            </>
        );
    };

    let getFilteredFixtures = (fixtures, search) => {
        if (fixtures) {
            if (search && search.length > 0) {
                return fixtures.filter(x => {
                    return search.some(y => x.homeTeamName == y || x.awayTeamName == y)
                })
            } else {
                return fixtures.filter(x => x.homeTeamName && x.homeTeamName !== '');
            }
        }
    }

    const filteredFixtures = React.useMemo(() => {
        let filteredFixtures = fixtures ? getFilteredFixtures(fixtures, search) : [];

        if (filteredFixtures) {
            if (sortConfig) {
                filteredFixtures.sort((a, b) => {
                    if (sortConfig.key == 'kickoff') {
                        if (a['date'] < b['date']) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (a['date'] > b['date']) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        } else {
                            if (a['kickoffTime'] < b['kickoffTime']) {
                                return sortConfig.direction === 'ascending' ? -1 : 1;
                            }
                            if (a['kickoffTime'] > b['kickoffTime']) {
                                return sortConfig.direction === 'ascending' ? 1 : -1;
                            }
                        }
                    } else {
                        if (a[sortConfig.key] < b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[sortConfig.key] > b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        }
                    }
                    return 0;
                });
            }
        }

        return filteredFixtures
    }, [fixtures, search, sortConfig]);


    let title = <h1 id="tabelLabel">Home</h1>;
    let contents = loading ? <p><em>Loading...</em></p> : renderTable(filteredFixtures);

    let modal = renderModal();

    let dropdown = renderDropdown(teamNames, setSearch);

    return (
        <div>
            {title}

            <Row className="mb-2 mr-0">
                <Col sm="6" lg="4">
                    {dropdown}
                </Col>
            </Row>

            {contents}

            {modal}
        </div>
    );
}

Home.displayName = Home.name;

export default Home;
